import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTypedSelector } from "@store";

interface Item {
  label: string;
  icon?: string;
  path?: string;
  subItems?: Item[];
  isAdmin?: boolean;
  isUAM?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    padding: theme.spacing(1),
    paddingRight: "10px",
    fontSize: ".95em",
    "&:hover": {
      cursor: "pointer",
    },
  },
  subItem: {
    paddingTop: "0px",
    paddingBottom: "0px",
    paddingLeft: theme.spacing(5),
    fontSize: "0.9em",
    "&:hover": {
      cursor: "pointer",
    },
  },
  subMenu: {
    backgroundColor: "white",
    padding: "0px",
  },
  icon: {
    padding: "0px 8px",
    minWidth: "0px",
  },
}));

const displayItem = (item: Item, isAdmin: boolean, isUAM: boolean): boolean => {
  let display = true;
  if (isAdmin) {
    display = true;
  } else if (item.label == "UAM" && isUAM) {
    display = true;
  } else {
    display = false;
  }

  return display;
};

export const Item: React.FC<Item> = ({ icon, label, path, subItems }) => {
  const userGroups: number[] = useTypedSelector(
    (state) => state.session?.userGroups || []
  );

  const isAdmin = userGroups.some((group) => group === 1);
  const isUAM = userGroups.some((group) => group === 4);

  const classNames = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const history = useHistory();
  const hasSubItems = !!subItems ? subItems.length > 0 : 0;
  const iconElement = !!icon ? (
    <ListItemIcon className={classNames.icon}>
      <i className={icon}></i>
    </ListItemIcon>
  ) : null;

  const handleClick = () => {
    setOpen(!open);
  };

  let subMenues = null;
  let menuItem = (
    <ListItem
      className={classNames.item}
      button
      onClick={() => history.push(`${path}`)}
    >
      {iconElement}
      <ListItemText disableTypography primary={label} />
    </ListItem>
  );
  if (!!hasSubItems) {
    subMenues = subItems?.map((subItem, index) =>
      displayItem(subItem, isAdmin, isUAM) ? (
        <ListItem
          key={index}
          button
          onClick={() =>
            subItem.path === "/dashboard/admin/workday-upload"
              ? window.open(process.env.REACT_APP_WORK_DAY_UPLOAD_URL)
              : subItem.path === "/dashboard/admin/dashboard"
              ? window.open("https://datastudio.google.com/s/tb9s_7HAqaY")
              : history.push(`${subItem.path}`)
          }
          className={classNames.subItem}
        >
          {!!subItem.icon ? <ListItemIcon>{subItem.icon}</ListItemIcon> : null}
          <ListItemText disableTypography primary={subItem.label} />
        </ListItem>
      ) : null
    );
    menuItem = (
      <React.Fragment>
        <ListItem onClick={handleClick} className={classNames.item}>
          {iconElement}
          <ListItemText disableTypography primary={label} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open}>
          <List component="div" className={classNames.subMenu}>
            {subMenues}
          </List>
        </Collapse>
      </React.Fragment>
    );
  }

  return menuItem;
};
